import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DefaultLayout from "../../layouts/DefaultLayout";
import { addNewStore } from "../../redux/actions/storeActions";
import { toast } from "react-toastify";
import { getListStoresUsers } from "../../redux/actions/userActions";
import GooglePlacesAutocomplete from "react-google-autocomplete";
// import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

// Imports pour react-leaflet
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMapEvents,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Configuration de l'icône par défaut de leaflet (pour éviter les problèmes d'affichage)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});
const API_MAP_KEY = "AIzaSyBtrUF56GBpFDiaXyLLGfdO8nIK5NWXUIU";

// Composant pour gérer les clics sur la carte dans le modal manuel
function ClickableMap({ manualLat, manualLng, setManualLat, setManualLng }) {
  useMapEvents({
    click(e) {
      setManualLat(e.latlng.lat);
      setManualLng(e.latlng.lng);
    },
  });
  return (
    <Marker position={[manualLat, manualLng]}>
      <Popup>Position actuelle</Popup>
    </Marker>
  );
}

function AddStoreScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();

  // None, Exist, New User
  const [userType, setUserType] = useState("None");

  const [selectUser, setSelectUser] = useState("");
  const [selectUserError, setSelectUserError] = useState("");

  const [firstName, setFirstName] = useState("");
  const [firstNameError, setFirstNameError] = useState("");

  const [lastName, setLastName] = useState("");
  const [lastNameError, setLastNameError] = useState("");

  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");

  const [phone, setPhone] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [passwordConfirm, setPasswordConfirm] = useState("");
  const [passwordConfirmError, setPasswordConfirmError] = useState("");

  const [storeName, setStoreName] = useState("");
  const [storeNameError, setStoreNameError] = useState("");

  const [storeLogoValue, setStoreLogoValue] = useState("");
  const [storeLogo, setStoreLogo] = useState("");
  const [storeLogoError, setStoreLogoError] = useState("");

  const [storeCoverValue, setStoreCoverValue] = useState("");
  const [storeCover, setStoreCover] = useState("");
  const [storeCoverError, setStoreCoverError] = useState("");

  const [storeType, setStoreType] = useState("");
  const [storeTypeError, setStoreTypeError] = useState("");

  const [storeDescription, setStoreDescription] = useState("");
  const [storeDescriptionError, setStoreDescriptionError] = useState("");

  const [storeAddress, setStoreAddress] = useState("");
  const [storeAddressError, setStoreAddressError] = useState("");

  const [locationX, setLocationX] = useState(0);
  const [locationXError, setLocationXError] = useState("");

  const [locationY, setLocationY] = useState(0);
  const [locationYError, setLocationYError] = useState("");

  const [storeTime, setStoreTime] = useState("");
  const [storeTimeError, setStoreTimeError] = useState("");

  const [storePhone, setStorePhone] = useState("");
  const [storePhoneError, setStorePhoneError] = useState("");

  const [storeEmail, setStoreEmail] = useState("");
  const [storeEmailError, setStoreEmailError] = useState("");

  // ----------------- Etats pour le modal de saisie manuelle -----------------
  const [showManualModal, setShowManualModal] = useState(false);
  const [manualAddress, setManualAddress] = useState("");
  const [manualAddressError, setManualAddressError] = useState("");
  const [manualLat, setManualLat] = useState(0);
  const [manualLng, setManualLng] = useState(0);

  // ----------------- Récupération des données utilisateurs -----------------

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const storeCreate = useSelector((state) => state.createNewStore);
  const { loadingStoreAdd, errorStoreAdd, successStoreAdd } = storeCreate;

  // usersListStoresUser
  const listUsersStores = useSelector((state) => state.usersListStoresUser);
  const { listStoresUser, loadingListStoresUser, errorListStoresUser, pages } =
    listUsersStores;

  const redirect = "/";
  useEffect(() => {
    if (!userInfo) {
      navigate(redirect);
    } else {
      dispatch(getListStoresUsers("0"));
    }
  }, [navigate, userInfo, dispatch]);

  // ----------------- Get user's current location -----------------
  // useEffect(() => {
  //   if ("geolocation" in navigator) {
  //     navigator.geolocation.getCurrentPosition(
  //       (position) => {
  //         const { latitude, longitude } = position.coords;
  //         setLocationX(latitude);
  //         setLocationY(longitude);
  //         // Also update manual modal defaults
  //         setManualLat(latitude);
  //         setManualLng(longitude);
  //       },
  //       (error) => {
  //         console.error("Error obtaining location:", error);
  //       }
  //     );
  //   }
  // }, []);

  useEffect(() => {
    if (successStoreAdd) {
      setStoreNameError("");
      setStoreLogoError("");
      setStoreCoverError("");
      setStoreTypeError("");
      setStoreDescriptionError("");
      setStoreTimeError("");

      setStoreName("");
      setStoreLogo("");
      setStoreLogoValue("");
      setStoreCover("");
      setStoreCoverValue("");
      setStoreType("");
      setStoreDescription("");
      setStoreTime("");
    }
  }, [successStoreAdd]);

  // ----------------- Style de la carte dans le modal -----------------
  const mapContainerStyle = {
    width: "100%",
    height: "300px",
  };

  return (
    <DefaultLayout>
      <div>
        {/* Breadcrumb */}
        <div className="flex flex-row text-sm items-center my-1">
          <a href="/dashboard">
            <div className="flex flex-row items-center hover:text-black">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75"
                />
              </svg>
              <span className="mx-1">Dashboard</span>
            </div>
          </a>
          <a href="/stores">
            <div className="flex flex-row items-center hover:text-black">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                className="w-4 h-4"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="m8.25 4.5 7.5 7.5-7.5 7.5"
                />
              </svg>
              <div>Stores List</div>
            </div>
          </a>
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth="1.5"
              stroke="currentColor"
              className="w-4 h-4"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="m8.25 4.5 7.5 7.5-7.5 7.5"
              />
            </svg>
          </span>
          <div>Create New Store</div>
        </div>

        {/* Titre */}
        <div className="py-5 px-4 flex justify-between">
          <h4 className="uppercase font-semibold text-black dark:text-white">
            New Store
          </h4>
        </div>

        {/* Formulaire principal */}
        <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
          <div className="my-2 bg-white py-4 px-2 rounded-md">
            {/* Sélection du type d'utilisateur */}
            <div className="flex md:flex-row flex-col">
              <div className="w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  User Store <strong className="text-danger">*</strong>
                </div>
                <div>
                  <select
                    className="outline-none border border-[#979fd38a] px-3 py-2 w-full rounded text-sm"
                    value={userType}
                    onChange={(e) => setUserType(e.target.value)}
                  >
                    <option value="None">Not Exist</option>
                    <option value="Exist">User Exist</option>
                    <option value="New User">New User</option>
                  </select>
                </div>
              </div>
            </div>

            {userType === "New User" && (
              <fieldset className="border rounded px-2 py-2">
                <legend className="text-black text-sm px-2">
                  Create New User
                </legend>
                <div className="flex md:flex-row flex-col">
                  <div className="md:w-1/2 w-full md:pr-1 my-1">
                    <div className="text-[#000000bf] font-bold text-xs mb-1">
                      First Name <strong className="text-danger">*</strong>
                    </div>
                    <input
                      type="text"
                      placeholder="First Name"
                      className={`outline-none border ${
                        firstNameError ? "border-danger" : "border-[#979fd38a]"
                      } px-3 py-2 w-full rounded text-sm`}
                      value={firstName}
                      onChange={(e) => setFirstName(e.target.value)}
                    />
                    <div className="text-[8px] text-danger">
                      {firstNameError || ""}
                    </div>
                  </div>
                  <div className="md:w-1/2 w-full md:pr-1 my-1">
                    <div className="text-[#000000bf] font-bold text-xs mb-1">
                      Last Name
                    </div>
                    <input
                      type="text"
                      placeholder="Last Name"
                      className={`outline-none border ${
                        lastNameError ? "border-danger" : "border-[#979fd38a]"
                      } px-3 py-2 w-full rounded text-sm`}
                      value={lastName}
                      onChange={(e) => setLastName(e.target.value)}
                    />
                    <div className="text-[8px] text-danger">
                      {lastNameError || ""}
                    </div>
                  </div>
                </div>
                <div className="flex md:flex-row flex-col">
                  <div className="md:w-1/2 w-full md:pr-1 my-1">
                    <div className="text-[#000000bf] font-bold text-xs mb-1">
                      Email <strong className="text-danger">*</strong>
                    </div>
                    <input
                      type="email"
                      placeholder="Email"
                      className={`outline-none border ${
                        emailError ? "border-danger" : "border-[#979fd38a]"
                      } px-3 py-2 w-full rounded text-sm`}
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                    <div className="text-[8px] text-danger">
                      {emailError || ""}
                    </div>
                  </div>
                  <div className="md:w-1/2 w-full md:pr-1 my-1">
                    <div className="text-[#000000bf] font-bold text-xs mb-1">
                      Phone <strong className="text-danger">*</strong>
                    </div>
                    <input
                      type="text"
                      placeholder="Phone"
                      className={`outline-none border ${
                        phoneError ? "border-danger" : "border-[#979fd38a]"
                      } px-3 py-2 w-full rounded text-sm`}
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                    <div className="text-[8px] text-danger">
                      {phoneError || ""}
                    </div>
                  </div>
                </div>
                <div className="flex md:flex-row flex-col">
                  <div className="md:w-1/2 w-full md:pr-1 my-1">
                    <div className="text-[#000000bf] font-bold text-xs mb-1">
                      Password <strong className="text-danger">*</strong>
                    </div>
                    <input
                      type="password"
                      placeholder="Password"
                      className={`outline-none border ${
                        passwordError ? "border-danger" : "border-[#979fd38a]"
                      } px-3 py-2 w-full rounded text-sm`}
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
                    <div className="text-[8px] text-danger">
                      {passwordError || ""}
                    </div>
                  </div>
                  <div className="md:w-1/2 w-full md:pr-1 my-1">
                    <div className="text-[#000000bf] font-bold text-xs mb-1">
                      Confirm Password{" "}
                      <strong className="text-danger">*</strong>
                    </div>
                    <input
                      type="password"
                      placeholder="Confirm Password"
                      className={`outline-none border ${
                        passwordConfirmError
                          ? "border-danger"
                          : "border-[#979fd38a]"
                      } px-3 py-2 w-full rounded text-sm`}
                      value={passwordConfirm}
                      onChange={(e) => setPasswordConfirm(e.target.value)}
                    />
                    <div className="text-[8px] text-danger">
                      {passwordConfirmError || ""}
                    </div>
                  </div>
                </div>
              </fieldset>
            )}

            {userType === "Exist" && (
              <div className="flex md:flex-row flex-col">
                <div className="w-full md:pr-1 my-1">
                  <div className="text-[#000000bf] font-bold text-xs mb-1">
                    Select User Store <strong className="text-danger">*</strong>
                  </div>
                  <select
                    className={`outline-none border ${
                      selectUserError ? "border-danger" : "border-[#979fd38a]"
                    } px-3 py-2 w-full rounded text-sm`}
                    value={selectUser}
                    onChange={(e) => setSelectUser(e.target.value)}
                  >
                    <option value="">Select User Store</option>
                    {listStoresUser?.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.full_name}
                      </option>
                    ))}
                  </select>
                  <div className="text-[8px] text-danger">
                    {selectUserError || ""}
                  </div>
                </div>
              </div>
            )}

            {/* Informations sur le store */}
            <div className="flex md:flex-row flex-col mt-2">
              <div className="md:w-1/2 w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Store Name <strong className="text-danger">*</strong>
                </div>
                <input
                  type="text"
                  placeholder="Store Name"
                  className={`outline-none border ${
                    storeNameError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  value={storeName}
                  onChange={(e) => setStoreName(e.target.value)}
                />
                <div className="text-[8px] text-danger">
                  {storeNameError || ""}
                </div>
              </div>
              <div className="md:w-1/2 w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Store Type <strong className="text-danger">*</strong>
                </div>
                <select
                  className={`outline-none border ${
                    storeTypeError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  value={storeType}
                  onChange={(e) => setStoreType(e.target.value)}
                >
                  <option value="">Select Type</option>
                  <option value="RESTAURANT">RESTAURANT</option>
                  <option value="GROCERIES">GROCERIES</option>
                </select>
                <div className="text-[8px] text-danger">
                  {storeTypeError || ""}
                </div>
              </div>
            </div>
            <div className="flex md:flex-row flex-col mt-2">
              <div className="md:w-1/2 w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Store Email <strong className="text-danger">*</strong>
                </div>
                <input
                  type="email"
                  placeholder="Store Email"
                  className={`outline-none border ${
                    storeEmailError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  value={storeEmail}
                  onChange={(e) => setStoreEmail(e.target.value)}
                />
                <div className="text-[8px] text-danger">
                  {storeEmailError || ""}
                </div>
              </div>
              <div className="md:w-1/2 w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Store Phone <strong className="text-danger">*</strong>
                </div>
                <input
                  type="text"
                  placeholder="Store Phone"
                  className={`outline-none border ${
                    storePhoneError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  value={storePhone}
                  onChange={(e) => setStorePhone(e.target.value)}
                />
                <div className="text-[8px] text-danger">
                  {storePhoneError || ""}
                </div>
              </div>
            </div>
            <div className="flex md:flex-row flex-col">
              <div className="md:w-1/2 w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Store Logo <strong className="text-danger">*</strong>
                </div>
                <input
                  type="file"
                  placeholder="Store Logo"
                  className={`outline-none border ${
                    storeLogoError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  value={storeLogoValue}
                  onChange={(e) => {
                    setStoreLogoValue(e.target.value);
                    setStoreLogo(e.target.files[0]);
                  }}
                />
                <div className="text-[8px] text-danger">
                  {storeLogoError || ""}
                </div>
              </div>
              <div className="md:w-1/2 w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Store Cover <strong className="text-danger">*</strong>
                </div>
                <input
                  type="file"
                  placeholder="Store Cover"
                  className={`outline-none border ${
                    storeCoverError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  value={storeCoverValue}
                  onChange={(e) => {
                    setStoreCoverValue(e.target.value);
                    setStoreCover(e.target.files[0]);
                  }}
                />
                <div className="text-[8px] text-danger">
                  {storeCoverError || ""}
                </div>
              </div>
            </div>
            <div className="flex md:flex-row flex-col">
              <div className="w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Store Description <strong className="text-danger">*</strong>
                </div>
                <textarea
                  placeholder="Store Description"
                  className={`outline-none border ${
                    storeDescriptionError
                      ? "border-danger"
                      : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  rows={6}
                  value={storeDescription}
                  onChange={(e) => setStoreDescription(e.target.value)}
                ></textarea>
                <div className="text-[8px] text-danger">
                  {storeDescriptionError || ""}
                </div>
              </div>
            </div>

            {/* Zone d'adresse avec Google Autocomplete */}
            <div className="flex md:flex-row flex-col">
              <div className="w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Store Address <strong className="text-danger">*</strong>
                </div>
                <input
                  type="text"
                  disabled
                  placeholder="Store Address"
                  className={`outline-none border ${
                    storeAddressError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm mb-2`}
                  value={storeAddress}
                  onChange={(e) => {
                    setStoreAddress(e.target.value);
                  }}
                />

                <GooglePlacesAutocomplete
                  apiKey={API_MAP_KEY} // Remplacez par votre clé
                  onPlaceSelected={(place) => {
                    if (place.geometry) {
                      setStoreAddress(place.formatted_address);
                      setLocationX(place.geometry.location.lat());
                      setLocationY(place.geometry.location.lng());
                    }
                  }}
                  placeholder="Search for address"
                  types={["address"]}
                  language="en"
                  className="w-full px-3 py-2 rounded text-sm border border-[#979fd38a]"
                />
                <div className="text-[8px] text-danger">
                  {storeAddressError || ""}
                </div>
                {/* Bouton pour ouvrir le modal de saisie manuelle */}
                <button
                  type="button"
                  className="mt-2 text-sm text-[#0388A6]"
                  onClick={() => {
                    setManualAddress("");
                    setManualLat(locationX);
                    setManualLng(locationY);
                    setShowManualModal(true);
                  }}
                >
                  Can't find your address? Enter it manually.
                </button>
              </div>
            </div>

            {/* Affichage des coordonnées actuelles */}
            <div className="flex md:flex-row flex-col my-3">
              <div className="md:w-1/2 w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Location X <strong className="text-danger">*</strong>
                </div>
                <input
                  type="number"
                  disabled
                  placeholder="Location X"
                  className={`outline-none border ${
                    locationXError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  value={locationX}
                  onChange={(e) => setLocationX(e.target.value)}
                />
                <div className="text-[8px] text-danger">
                  {locationXError || ""}
                </div>
              </div>
              <div className="md:w-1/2 w-full md:pr-1 my-1">
                <div className="text-[#000000bf] font-bold text-xs mb-1">
                  Location Y <strong className="text-danger">*</strong>
                </div>
                <input
                  type="number"
                  disabled
                  placeholder="Location Y"
                  className={`outline-none border ${
                    locationYError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                  value={locationY}
                  onChange={(e) => setLocationY(e.target.value)}
                />
                <div className="text-[8px] text-danger">
                  {locationYError || ""}
                </div>
              </div>
            </div>

            {/* Bouton de soumission */}
            <div className="flex flex-row items-center justify-end my-3">
              <a
                href="/categories"
                className="bg-white text-[#0388A6] text-sm px-5 py-3 rounded-full mr-3"
              >
                Back
              </a>
              <button
                onClick={async () => {
                  let check = true;
                  // Réinitialisation des messages d'erreur
                  setStoreNameError("");
                  setStoreLogoError("");
                  setStoreCoverError("");
                  setStoreTypeError("");
                  setStoreDescriptionError("");
                  setStoreTimeError("");
                  setEmailError("");
                  setPhoneError("");
                  setFirstNameError("");
                  setLastNameError("");
                  setPasswordError("");
                  setPasswordConfirmError("");
                  setSelectUserError("");
                  setStoreEmailError("");
                  setStorePhoneError("");
                  setStoreAddressError("");
                  setLocationXError("");
                  setLocationYError("");

                  if (userType === "Exist") {
                    if (selectUser === "") {
                      setSelectUserError("These fields are required.");
                      check = false;
                    }
                  } else if (userType === "New User") {
                    if (firstName === "") {
                      setFirstNameError("These fields are required.");
                      check = false;
                    }
                    if (email === "") {
                      setEmailError("These fields are required.");
                      check = false;
                    }
                    if (phone === "") {
                      setPhoneError("These fields are required.");
                      check = false;
                    }
                    if (password === "") {
                      setPasswordError("These fields are required.");
                      check = false;
                    } else if (password !== passwordConfirm) {
                      setPasswordError("Please confirm password.");
                      check = false;
                    }
                  }
                  if (storeName === "") {
                    setStoreNameError("These fields are required.");
                    check = false;
                  }
                  if (storeType === "") {
                    setStoreTypeError("These fields are required.");
                    check = false;
                  }
                  if (storeEmail === "") {
                    setStoreEmailError("These fields are required.");
                    check = false;
                  }
                  if (storePhone === "") {
                    setStorePhoneError("These fields are required.");
                    check = false;
                  }
                  if (!storeLogoValue) {
                    setStoreLogoError("These fields are required.");
                    check = false;
                  }
                  if (!storeCoverValue) {
                    setStoreCoverError("These fields are required.");
                    check = false;
                  }
                  if (storeDescription === "") {
                    setStoreDescriptionError("These fields are required.");
                    check = false;
                  }
                  if (storeAddress === "") {
                    setStoreAddressError("These fields are required.");
                    check = false;
                  }
                  if (locationX === "") {
                    setLocationXError("These fields are required.");
                    check = false;
                  }
                  if (locationY === "") {
                    setLocationYError("These fields are required.");
                    check = false;
                  }
                  if (check) {
                    let full_name = firstName;
                    if (lastName !== "") {
                      full_name += " " + lastName;
                    }
                    await dispatch(
                      addNewStore({
                        user_type: userType,
                        user_select: userType === "Exist" ? selectUser : "",
                        store_name: storeName,
                        store_logo: storeLogo,
                        store_cover: storeCover,
                        store_type: storeType,
                        store_description: storeDescription,
                        store_address: storeAddress,
                        location_x: locationX,
                        location_y: locationY,
                        store_phone: storePhone,
                        store_email: storeEmail,
                        user_email: userType === "New User" ? email : "",
                        user_phone: userType === "New User" ? phone : "",
                        user_first_name:
                          userType === "New User" ? firstName : "",
                        user_last_name: userType === "New User" ? lastName : "",
                        user_full_name:
                          userType === "New User" ? full_name : "",
                        user_password: userType === "New User" ? password : "",
                      })
                    ).then(() => {});
                  } else {
                    toast.error(
                      "Some fields are empty or invalid. Please try again."
                    );
                  }
                }}
                className="text-white bg-[#0388A6] text-sm px-5 py-3 rounded-full"
              >
                {loadingStoreAdd ? "Loading ..." : "Create Store"}
              </button>
            </div>
          </div>
        </div>

        {/* Modal de saisie manuelle avec MapContainer de react-leaflet */}
        {showManualModal && (
          <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white p-4 rounded-md w-11/12 max-w-md">
              <h3 className="text-lg font-bold mb-4">
                Search for address manually
              </h3>
              <div className="mb-4">
                <input
                  type="text"
                  placeholder="Enter the address"
                  value={manualAddress}
                  onChange={(e) => setManualAddress(e.target.value)}
                  className={`outline-none border ${
                    manualAddressError ? "border-danger" : "border-[#979fd38a]"
                  } px-3 py-2 w-full rounded text-sm`}
                />
                <div className="text-[8px] text-danger">
                  {manualAddressError || ""}
                </div>
              </div>
              <div className="mb-4">
                <MapContainer
                  center={[manualLat || 0, manualLng || 0]}
                  zoom={15}
                  style={mapContainerStyle}
                >
                  <TileLayer
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                  />
                  <ClickableMap
                    manualLat={manualLat}
                    manualLng={manualLng}
                    setManualLat={setManualLat}
                    setManualLng={setManualLng}
                  />
                </MapContainer>
              </div>
              <div className="flex justify-end">
                <button
                  type="button"
                  onClick={() => setShowManualModal(false)}
                  className="mr-2 px-4 py-2 border rounded"
                >
                  Cancel
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setManualAddressError("");
                    if (manualAddress === "") {
                      toast("Please enter store address");
                      setManualAddressError("This is required.");
                    } else {
                      // Sauvegarde des infos manuelles dans le formulaire principal
                      setStoreAddress(manualAddress);
                      setStoreAddress(manualAddress);
                      setLocationX(manualLat);
                      setLocationY(manualLng);
                      setShowManualModal(false);
                    }
                  }}
                  className="px-4 py-2 bg-[#0388A6] text-white rounded"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </DefaultLayout>
  );

  // return (
  //   <DefaultLayout>
  //     <div>
  //       <div className="flex flex-row text-sm items-center my-1">
  //         {/* home */}
  //         <a href="/dashboard">
  //           <div className="flex flex-row  items-center hover:text-black ">
  //             <svg
  //               xmlns="http://www.w3.org/2000/svg"
  //               fill="none"
  //               viewBox="0 0 24 24"
  //               stroke-width="1.5"
  //               stroke="currentColor"
  //               className="w-4 h-4"
  //             >
  //               <path
  //                 strokeLinecap="round"
  //                 strokeLinejoin="round"
  //                 d="m2.25 12 8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
  //               />
  //             </svg>
  //             <span className="mx-1">Dashboard</span>
  //           </div>
  //         </a>
  //         <a href="/stores">
  //           <div className="flex flex-row  items-center hover:text-black ">
  //             <span>
  //               <svg
  //                 xmlns="http://www.w3.org/2000/svg"
  //                 fill="none"
  //                 viewBox="0 0 24 24"
  //                 stroke-width="1.5"
  //                 stroke="currentColor"
  //                 className="w-4 h-4"
  //               >
  //                 <path
  //                   strokeLinecap="round"
  //                   strokeLinejoin="round"
  //                   d="m8.25 4.5 7.5 7.5-7.5 7.5"
  //                 />
  //               </svg>
  //             </span>
  //             <div className="">Stores List</div>
  //           </div>
  //         </a>
  //         <span>
  //           <svg
  //             xmlns="http://www.w3.org/2000/svg"
  //             fill="none"
  //             viewBox="0 0 24 24"
  //             stroke-width="1.5"
  //             stroke="currentColor"
  //             className="w-4 h-4"
  //           >
  //             <path
  //               strokeLinecap="round"
  //               strokeLinejoin="round"
  //               d="m8.25 4.5 7.5 7.5-7.5 7.5"
  //             />
  //           </svg>
  //         </span>
  //         <div className="">Create New Store</div>
  //       </div>
  //       {/*  */}
  //       <div className="py-5 px-4 flex justify-between">
  //         <h4 className=" uppercase font-semibold text-black dark:text-white">
  //           New Store
  //         </h4>
  //       </div>
  //       {/*  */}
  //       <div className="rounded-sm border border-stroke bg-white px-5 pt-6 pb-2.5 shadow-default dark:border-strokedark dark:bg-boxdark sm:px-7.5 xl:pb-1">
  //         <div className="my-2 bg-white py-4 px-2 rounded-md">
  //           {/*  */}
  //           <div className="flex md:flex-row flex-col  ">
  //             <div className=" w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 User Store <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <select
  //                   className={` outline-none border border-[#979fd38a] px-3 py-2 w-full rounded text-sm`}
  //                   value={userType}
  //                   onChange={(v) => setUserType(v.target.value)}
  //                 >
  //                   <option value={"None"}>Not Exist</option>
  //                   <option value={"Exist"}>User Exist</option>
  //                   <option value={"New User"}>New User</option>
  //                 </select>
  //               </div>
  //             </div>
  //           </div>
  //           {userType === "New User" ? (
  //             <div>
  //               <fieldset className="border rounded px-2 py-2">
  //                 <legend className="text-black text-sm px-2">
  //                   Create New User
  //                 </legend>
  //                 <div className="flex md:flex-row flex-col  ">
  //                   <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //                     <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                       First Name <strong className="text-danger">*</strong>
  //                     </div>
  //                     <div>
  //                       <input
  //                         className={` outline-none border ${
  //                           firstNameError
  //                             ? "border-danger"
  //                             : "border-[#979fd38a]"
  //                         } px-3 py-2 w-full rounded text-sm`}
  //                         type="text"
  //                         placeholder="First Name"
  //                         value={firstName}
  //                         onChange={(v) => setFirstName(v.target.value)}
  //                       />
  //                       <div className=" text-[8px] text-danger">
  //                         {firstNameError ? firstNameError : ""}
  //                       </div>
  //                     </div>
  //                   </div>
  //                   {/*  */}
  //                   <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //                     <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                       Last Name
  //                     </div>
  //                     <div>
  //                       <input
  //                         className={` outline-none border ${
  //                           lastNameError
  //                             ? "border-danger"
  //                             : "border-[#979fd38a]"
  //                         } px-3 py-2 w-full rounded text-sm`}
  //                         type="text"
  //                         placeholder="Last Name"
  //                         value={lastName}
  //                         onChange={(v) => setLastName(v.target.value)}
  //                       />
  //                       <div className=" text-[8px] text-danger">
  //                         {lastNameError ? lastNameError : ""}
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //                 {/*  */}
  //                 <div className="flex md:flex-row flex-col  ">
  //                   <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //                     <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                       Email <strong className="text-danger">*</strong>
  //                     </div>
  //                     <div>
  //                       <input
  //                         className={` outline-none border ${
  //                           emailError ? "border-danger" : "border-[#979fd38a]"
  //                         } px-3 py-2 w-full rounded text-sm`}
  //                         type="email"
  //                         placeholder="Email"
  //                         value={email}
  //                         onChange={(v) => setEmail(v.target.value)}
  //                       />
  //                       <div className=" text-[8px] text-danger">
  //                         {emailError ? emailError : ""}
  //                       </div>
  //                     </div>
  //                   </div>
  //                   {/*  */}
  //                   <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //                     <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                       Phone <strong className="text-danger">*</strong>
  //                     </div>
  //                     <div>
  //                       <input
  //                         className={` outline-none border ${
  //                           phoneError ? "border-danger" : "border-[#979fd38a]"
  //                         } px-3 py-2 w-full rounded text-sm`}
  //                         type="text"
  //                         placeholder="Phone"
  //                         value={phone}
  //                         onChange={(v) => setPhone(v.target.value)}
  //                       />
  //                       <div className=" text-[8px] text-danger">
  //                         {phoneError ? phoneError : ""}
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //                 {/*  */}
  //                 <div className="flex md:flex-row flex-col  ">
  //                   <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //                     <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                       Password <strong className="text-danger">*</strong>
  //                     </div>
  //                     <div>
  //                       <input
  //                         className={` outline-none border ${
  //                           passwordError
  //                             ? "border-danger"
  //                             : "border-[#979fd38a]"
  //                         } px-3 py-2 w-full rounded text-sm`}
  //                         type="password"
  //                         placeholder="Password"
  //                         value={password}
  //                         onChange={(v) => setPassword(v.target.value)}
  //                       />
  //                       <div className=" text-[8px] text-danger">
  //                         {passwordError ? passwordError : ""}
  //                       </div>
  //                     </div>
  //                   </div>
  //                   {/*  */}
  //                   <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //                     <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                       Confirm Password{" "}
  //                       <strong className="text-danger">*</strong>
  //                     </div>
  //                     <div>
  //                       <input
  //                         className={` outline-none border ${
  //                           passwordConfirmError
  //                             ? "border-danger"
  //                             : "border-[#979fd38a]"
  //                         } px-3 py-2 w-full rounded text-sm`}
  //                         type="password"
  //                         placeholder="Confirm Password"
  //                         value={passwordConfirm}
  //                         onChange={(v) => setPasswordConfirm(v.target.value)}
  //                       />
  //                       <div className=" text-[8px] text-danger">
  //                         {passwordConfirmError ? passwordConfirmError : ""}
  //                       </div>
  //                     </div>
  //                   </div>
  //                 </div>
  //               </fieldset>
  //             </div>
  //           ) : null}
  //           {userType === "Exist" ? (
  //             <div className="flex md:flex-row flex-col  ">
  //               <div className=" w-full  md:pr-1 my-1">
  //                 <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                   Select User Store <strong className="text-danger">*</strong>
  //                 </div>
  //                 <div>
  //                   <select
  //                     className={` outline-none border ${
  //                       selectUserError ? "border-danger" : "border-[#979fd38a]"
  //                     } px-3 py-2 w-full rounded text-sm`}
  //                     value={selectUser}
  //                     onChange={(v) => setSelectUser(v.target.value)}
  //                   >
  //                     <option value={""}>Select User Store</option>
  //                     {listStoresUser?.map((item, index) => (
  //                       <option value={item.id}>{item.full_name}</option>
  //                     ))}
  //                   </select>
  //                   <div className=" text-[8px] text-danger">
  //                     {selectUserError ? selectUserError : ""}
  //                   </div>
  //                 </div>
  //               </div>
  //             </div>
  //           ) : null}

  //           <div className="flex md:flex-row flex-col  mt-2">
  //             <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Store Name <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <input
  //                   className={` outline-none border ${
  //                     storeNameError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   type="text"
  //                   placeholder="Store Name"
  //                   value={storeName}
  //                   onChange={(v) => setStoreName(v.target.value)}
  //                 />
  //                 <div className=" text-[8px] text-danger">
  //                   {storeNameError ? storeNameError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //             {/*  */}
  //             <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Store Type <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <select
  //                   className={` outline-none border ${
  //                     storeTypeError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   value={storeType}
  //                   onChange={(v) => setStoreType(v.target.value)}
  //                 >
  //                   <option value={""}>Select Type</option>
  //                   <option value={"RESTAURANT"}>RESTAURANT</option>
  //                   <option value={"GROCERIES"}>GROCERIES</option>
  //                 </select>

  //                 <div className=" text-[8px] text-danger">
  //                   {storeTypeError ? storeTypeError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           {/*  */}
  //           <div className="flex md:flex-row flex-col  mt-2">
  //             <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Store Email <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <input
  //                   className={` outline-none border ${
  //                     storeEmailError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   type="email"
  //                   placeholder="Store Email"
  //                   value={storeEmail}
  //                   onChange={(v) => setStoreEmail(v.target.value)}
  //                 />
  //                 <div className=" text-[8px] text-danger">
  //                   {storeEmailError ? storeEmailError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //             {/*  */}
  //             <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Store Phone <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <input
  //                   className={` outline-none border ${
  //                     storePhoneError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   type="phone"
  //                   placeholder="Store Phone"
  //                   value={storePhone}
  //                   onChange={(v) => setStorePhone(v.target.value)}
  //                 />

  //                 <div className=" text-[8px] text-danger">
  //                   {storePhoneError ? storePhoneError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>

  //           {/*  */}
  //           <div className="flex md:flex-row flex-col  ">
  //             <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Store Logo <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <input
  //                   className={` outline-none border ${
  //                     storeLogoError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   type="file"
  //                   placeholder="First Name"
  //                   value={storeLogoValue}
  //                   onChange={(v) => {
  //                     setStoreLogoValue(v.target.value);
  //                     setStoreLogo(v.target.files[0]);
  //                   }}
  //                 />
  //                 <div className=" text-[8px] text-danger">
  //                   {storeLogoError ? storeLogoError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //             {/*  */}
  //             <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Store Cover <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <input
  //                   className={` outline-none border ${
  //                     storeCoverError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   type="file"
  //                   placeholder="First Name"
  //                   value={storeCoverValue}
  //                   onChange={(v) => {
  //                     setStoreCoverValue(v.target.value);
  //                     setStoreCover(v.target.files[0]);
  //                   }}
  //                 />
  //                 <div className=" text-[8px] text-danger">
  //                   {storeCoverError ? storeCoverError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           {/*  */}
  //           <div className="flex md:flex-row flex-col  ">
  //             <div className=" w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Store Description <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <textarea
  //                   className={` outline-none border ${
  //                     storeDescriptionError
  //                       ? "border-danger"
  //                       : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   placeholder="First Name"
  //                   value={storeDescription}
  //                   onChange={(v) => {
  //                     setStoreDescription(v.target.value);
  //                   }}
  //                   rows={6}
  //                 ></textarea>
  //                 <div className=" text-[8px] text-danger">
  //                   {storeDescriptionError ? storeDescriptionError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           {/*  */}
  //           <div className="flex md:flex-row flex-col  ">
  //             <div className=" w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Store Address <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <input
  //                   className={` outline-none border ${
  //                     storeAddressError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   type="text"
  //                   placeholder="Address"
  //                   value={storeAddress}
  //                   onChange={(v) => setStoreAddress(v.target.value)}
  //                 />
  //                 <div className=" text-[8px] text-danger">
  //                   {storeAddressError ? storeAddressError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           <div className="flex md:flex-row flex-col  ">
  //             <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Location X <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <input
  //                   className={` outline-none border ${
  //                     locationXError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   type="number"
  //                   placeholder="Location X"
  //                   value={locationX}
  //                   onChange={(v) => setLocationX(v.target.value)}
  //                 />
  //                 <div className=" text-[8px] text-danger">
  //                   {locationXError ? locationXError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //             {/*  */}
  //             <div className="md:w-1/2 w-full  md:pr-1 my-1">
  //               <div className="text-[#000000bf] font-bold text-xs  mb-1">
  //                 Location Y <strong className="text-danger">*</strong>
  //               </div>
  //               <div>
  //                 <input
  //                   className={` outline-none border ${
  //                     locationYError ? "border-danger" : "border-[#979fd38a]"
  //                   } px-3 py-2 w-full rounded text-sm`}
  //                   type="number"
  //                   placeholder="Location Y"
  //                   value={locationY}
  //                   onChange={(v) => setLocationY(v.target.value)}
  //                 />
  //                 <div className=" text-[8px] text-danger">
  //                   {locationYError ? locationYError : ""}
  //                 </div>
  //               </div>
  //             </div>
  //           </div>
  //           {/*  */}
  //           <div className="my-3 ">
  //             <div className="flex flex-row items-center justify-end my-3">
  //               <a
  //                 href="/categories"
  //                 className="bg-white text-[#0388A6] text-sm px-5 py-3 rounded-full mr-3"
  //               >
  //                 Back
  //               </a>
  //               <button
  //                 onClick={async () => {
  //                   var check = true;
  //                   setStoreNameError("");
  //                   setStoreLogoError("");
  //                   setStoreCoverError("");
  //                   setStoreTypeError("");
  //                   setStoreDescriptionError("");
  //                   setStoreTimeError("");

  //                   setEmailError("");
  //                   setPhoneError("");
  //                   setFirstNameError("");
  //                   setLastNameError("");
  //                   setPasswordError("");
  //                   setPasswordConfirmError("");

  //                   setSelectUserError("");

  //                   setStoreEmailError("");
  //                   setStorePhoneError("");

  //                   setStoreAddressError("");
  //                   setLocationXError("");
  //                   setLocationYError("");

  //                   if (userType === "Exist") {
  //                     if (selectUser === "") {
  //                       setSelectUserError("These fields are required.");
  //                       check = false;
  //                     }
  //                   } else if (userType === "New User") {
  //                     if (firstName === "") {
  //                       setFirstNameError("These fields are required.");
  //                       check = false;
  //                     }
  //                     if (email === "") {
  //                       setEmailError("These fields are required.");
  //                       check = false;
  //                     }
  //                     if (phone === "") {
  //                       setPhoneError("These fields are required.");
  //                       check = false;
  //                     }

  //                     if (password === "") {
  //                       setPasswordError("These fields are required.");
  //                       check = false;
  //                     } else if (password !== passwordConfirm) {
  //                       setPasswordError("Please confirm password.");
  //                       check = false;
  //                     }
  //                   }

  //                   if (storeName === "") {
  //                     setStoreNameError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (storeType === "") {
  //                     setStoreTypeError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (storeEmail === "") {
  //                     setStoreEmailError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (storePhone === "") {
  //                     setStorePhoneError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (storeLogoValue === "") {
  //                     setStoreLogoError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (storeCoverValue === "") {
  //                     setStoreCoverError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (storeDescription === "") {
  //                     setStoreDescriptionError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (storeAddress === "") {
  //                     setStoreAddressError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (locationX === "") {
  //                     setLocationXError("These fields are required.");
  //                     check = false;
  //                   }
  //                   if (locationY === "") {
  //                     setLocationYError("These fields are required.");
  //                     check = false;
  //                   }

  //                   if (check) {
  //                     var full_name = firstName;
  //                     if (lastName !== "") {
  //                       full_name += " " + lastName;
  //                     }
  //                     // setLoadEvent(true);
  //                     await dispatch(
  //                       addNewStore({
  //                         user_type: userType,
  //                         user_select: userType === "Exist" ? selectUser : "",
  //                         store_name: storeName,
  //                         store_logo: storeLogo,
  //                         store_cover: storeCover,
  //                         store_type: storeType,
  //                         store_description: storeDescription,
  //                         store_address: storeAddress,
  //                         location_x: locationX,
  //                         location_y: locationY,
  //                         store_phone: storePhone,
  //                         store_email: storeEmail,
  //                         // create user
  //                         user_email: userType === "New User" ? email : "",
  //                         user_phone: userType === "New User" ? phone : "",
  //                         user_first_name:
  //                           userType === "New User" ? firstName : "",
  //                         user_last_name:
  //                           userType === "New User" ? lastName : "",
  //                         user_full_name:
  //                           userType === "New User" ? full_name : "",
  //                         user_password:
  //                           userType === "New User" ? password : "",
  //                       })
  //                     ).then(() => {});
  //                     // setLoadEvent(false);
  //                   } else {
  //                     toast.error(
  //                       "Some fields are empty or invalid. please try again"
  //                     );
  //                   }
  //                 }}
  //                 className="text-white bg-[#0388A6] text-sm px-5 py-3 rounded-full"
  //               >
  //                 {loadingStoreAdd ? "Loading ..." : "Create Store"}
  //               </button>
  //             </div>
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   </DefaultLayout>
  // );
}

export default AddStoreScreen;
